module.exports = __webpack_public_path__ + "static/media/icons8-linux.b786a85e.svg";